import { c as _c } from "react/compiler-runtime";
import { Select, Typography, Stack } from '@mui/material';
import { useState } from 'react';
import { DateTimePopover } from '@/components/date/dateTimePopover';
import { dayjs, DATE_FORMAT, type Dayjs } from '@/utils/dayjs';
export const FromToSelector = t0 => {
  const $ = _c(19);
  const {
    selectedFrom,
    selectedTo,
    setSelectedFrom,
    setSelectedTo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "12px",
      alignItems: "center",
      border: "1px solid var(--mui-palette-divider)",
      borderRadius: "var(--mui-shape-customBorderRadius-sm)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== setSelectedFrom) {
    t2 = value => setSelectedFrom(value.startOf("minute"));
    $[1] = setSelectedFrom;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = dayjs.utc().endOf("day");
    t4 = dayjs.utc("2024-01-01");
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== selectedFrom || $[6] !== t2) {
    t5 = <DateTimeSelector dateTime={selectedFrom} onChange={t2} maxDate={t3} minDate={t4} />;
    $[5] = selectedFrom;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Typography variant="subtitle1">and</Typography>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== setSelectedTo) {
    t7 = value_0 => setSelectedTo(value_0.endOf("minute"));
    $[9] = setSelectedTo;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = dayjs.utc().endOf("day");
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== selectedFrom || $[13] !== selectedTo || $[14] !== t7) {
    t9 = <DateTimeSelector dateTime={selectedTo} onChange={t7} maxDate={t8} minDate={selectedFrom} />;
    $[12] = selectedFrom;
    $[13] = selectedTo;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t5 || $[17] !== t9) {
    t10 = <><Stack direction="row" sx={t1}>{t5}{t6}{t9}</Stack></>;
    $[16] = t5;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
interface DateTimeSelectorProps {
  dateTime: Dayjs;
  onChange: (date: Dayjs) => void;
  maxDate?: Dayjs;
  minDate?: Dayjs;
  title?: string;
}
export const DateTimeSelector = props => {
  const $ = _c(3);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] !== isOpen || $[1] !== props) {
    t0 = <ControlledDateTimeSelector {...props} open={isOpen} onOpenChange={setIsOpen} />;
    $[0] = isOpen;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export const ControlledDateTimeSelector = t0 => {
  const $ = _c(22);
  const {
    dateTime,
    onChange,
    maxDate,
    minDate,
    title,
    open,
    onOpenChange
  } = t0;
  const [anchorEl, setAnchorEl] = useState(null);
  let t1;
  if ($[0] !== onChange || $[1] !== onOpenChange) {
    t1 = selectedDate => {
      onOpenChange(false);
      onChange(selectedDate);
    };
    $[0] = onChange;
    $[1] = onOpenChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClose = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      readOnly: true
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onOpenChange) {
    t3 = () => onOpenChange(true);
    $[4] = onOpenChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== dateTime) {
    t4 = () => <Typography variant="subtitle1" className="font-medium">{dateTime.format(DATE_FORMAT)} {dateTime.format("HH:mm")}</Typography>;
    $[6] = dateTime;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <Select ref={setAnchorEl} inputProps={t2} displayEmpty={true} onClick={t3} variant="standard" value="" renderValue={t4} readOnly={true} />;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== anchorEl || $[12] !== dateTime || $[13] !== handleClose || $[14] !== maxDate || $[15] !== minDate || $[16] !== open || $[17] !== title) {
    t6 = <DateTimePopover value={dateTime} onChange={handleClose} anchorEl={anchorEl} open={open} maxDate={maxDate} minDate={minDate} title={title} />;
    $[11] = anchorEl;
    $[12] = dateTime;
    $[13] = handleClose;
    $[14] = maxDate;
    $[15] = minDate;
    $[16] = open;
    $[17] = title;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};